import React from 'react'

const MedicalCardsTitle = ({title}) => {
  return (
    <p  className='font-semibold cards__heading'>{title}</p>
  )
}

export default MedicalCardsTitle